import { Component, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';
import { NgClass } from '@angular/common';
import { TableRowData } from '@app/shared/models/table-data-types';

@Component({
    selector: 'app-qs-status-column',
    template: `
        <div class="tw-flex tw-justify-center">
            @if (value() != null) {
                <mat-icon
                    fontSet="material-symbols-outlined"
                    style="font-variation-settings: 'FILL' 1"
                    [ngClass]="{
                        'tw-text-red-500': value() === 'red',
                        'tw-text-yellow-500': value() === 'yellow',
                        'tw-text-green-500': value() === 'green',
                    }">
                    @if (value() === 'red') {
                        cancel
                    } @else if (value() === 'yellow') {
                        circle
                    } @else if (value() === 'green') {
                        check_circle
                    }
                </mat-icon>
            }
        </div>
    `,
    standalone: true,
    imports: [TranslateModule, MatIconModule, MatTooltipModule, NgClass],
})
export class QsStatusComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
}
